import React from 'react';
import {ScrollView, StyleSheet, Text, View} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';
import {styles as popoverProviderStyles} from '/provider/PopoverProvider/PopoverProvider.style';

import InfoPopover from '../InfoPopover';

const storyStyle = StyleSheet.create({
  popoverContentWrapper: {
    width: '100%',
  },
});

storiesOf('partial', module).add('InfoPopover', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView expand={true}>
        <Heading level={1}>Info Popover</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>InfoPopover</Code> component is used to render popover with
          header and body text.
        </Text>
        <Spacer size={16} />
        <View
          style={[
            popoverProviderStyles.contentWrapper,
            storyStyle.popoverContentWrapper,
          ]}>
          <InfoPopover
            heading="Multi-Spatial Probe"
            body="A multi-spatial probe was an advanced probe carried by USS Voyager. Apart from incorporating multi-spatial technology, it was equipped with unimatrix shielding designed by Lieutenant Commander Tuvok. Other features were a telemetry link, and the ability to emit a polaron burst."
          />
        </View>
        <Spacer size={16} />
        <Text>
          The heading and body text of the popover is specified by the{' '}
          <Code>heading</Code> and <Code>body</Code> props respectively.
        </Text>
        <Spacer size={6} />
        <Code>{'<InfoPopover'}</Code>
        <Code>{'  heading="Multi-Spatial Probe"'}</Code>
        <Code>{'  body="A multi-spatial probe was an ..."'}</Code>
        <Code>{'/>'}</Code>
      </FlexView>
    </Spacing>
  </ScrollView>
));
